import { type BrandTheme } from '@owner/theme'

import type { CoreState } from '../../types'

export const SET_THEME = (state: CoreState, theme: BrandTheme): void => {
  state.theme = theme
}
